export default __webpack_public_path__ + "static/media/cmk2020-template.e7fc280c.zip";